import HttpError from './httpError'

const fetchJson = (url, options = {}) => {
  // eslint-disable-next-line
  const requestHeaders = options.headers || new Headers({
    'Accept': 'application/vnd.api+json'
  })

  // eslint-disable-next-line
  if (!(options && options.body && options.body instanceof FormData)) {
    requestHeaders.set('Content-Type', 'application/vnd.api+json')
  }

  if (options.user && options.user.authenticated && options.user.token) {
    requestHeaders.set('Authorization', options.user.token)
  }

  // eslint-disable-next-line
  return fetch(url, { ...options, headers: requestHeaders })
    .then(response => response.text().then(text => ({
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      body: text
    })))
    .then(({ status, statusText, headers, body }) => {
      let json

      try {
        json = JSON.parse(body)
      } catch (e) {
        // not json, no big deal
      }

      if (status < 200 || status >= 300) {
        return Promise.reject(new HttpError((json && json.message) || statusText, status))
      }

      return { status, headers, body, json }
    })
}

export const jsonApiHttpClient = (url, options = {}) => {
  if (!options.headers) {
    // eslint-disable-next-line
    options.headers = new Headers({ 'Accept': 'application/vnd.api+json' })
  }

  options.headers.set('Content-Type', 'application/vnd.api+json')

  return fetchJson(url, options)
}

export const queryParameters = data => Object.keys(data)
  .map(key => [key, data[key]].map(encodeURIComponent).join('='))
  .join('&')

export const handleFilters = (filter) => {
  let params = false

  params = filter._gasStation ? `{"_gasStation" : "${filter._gasStation}"}` : params
  params = filter._organization ? `{"_organization" : "${filter._organization}"}` : params

  const filters = params ? {$where: params} : {}

  return {...filters}
}

export const handleSort = ({ field, order }) => {
  field = field === 'id' ? '_id' : field
  return `${order === 'DESC' ? '-' : ''}${field}`
}



// WEBPACK FOOTER //
// ./src/services/fetch.js